import styles from './styles.module.scss';
import { gameDetailsTabsOptions } from './options';
import { GameDetailsTabsProps } from './props';
import { Tabs } from '@starsoft/common/components';
import { SettingLayoutComponentId } from '@starsoft/common/models';

export default function GameDetailsTabs({
  current,
  onTabChange,
}: GameDetailsTabsProps) {
  return (
    <div className={styles.container}>
      <Tabs
        tabs={gameDetailsTabsOptions}
        setTab={onTabChange}
        currentTab={current}
        useMaxContent
        version={SettingLayoutComponentId.TabsV3?.toString()}
      />
    </div>
  );
}
